import { PROJECT_BASENAME } from 'constants/env';

export const getBasePath = () => {
  const path = `${window.location.origin}${PROJECT_BASENAME}`;
  return path;
};
